import { GridColDef } from '@mui/x-data-grid';

export interface TrendingPlace {
  id: string;
  position: number;
  manualPosition: number | string;
  zscore: number | string;
  placeName: string;
  placeId: string;
  imageId: string;
  brand: string;
  region: string;
  enforcedPosition?: boolean;
}

export const defaultFields: Partial<GridColDef> = {
  sortable: false,
  disableColumnMenu: true,
  flex: 1,
  display: 'flex',
  type: 'singleSelect',
};

export const defaultColumns: Array<GridColDef<TrendingPlace>> = [
  {
    ...defaultFields,
    field: 'position',
    headerName: 'Position',
    flex: undefined,
    width: 80,
  },
  {
    ...defaultFields,
    field: 'manualPosition',
    headerName: 'Manual Position',
    flex: undefined,
    width: 120,
  },
  {
    ...defaultFields,
    field: 'zscore',
    headerName: 'Impression Score',
    flex: undefined,
    width: 120,
  },
  {
    ...defaultFields,
    field: 'placeName',
    headerName: 'Place Name',
    minWidth: 180,
  },
];
